/* PJS · Klaviyo capture bridge
   Mirrors every native Shopify newsletter signup (forms posting to /contact tagged 'newsletter')
   into Klaviyo list XtznP8 so the live Welcome + STUDIO15 flow triggers reliably.
   Uses Klaviyo's public list-subscribe endpoint (public list id only, no secrets).
   Dual-writes alongside Shopify's native capture; never blocks the native form. */
(function () {
  var KLAVIYO_LIST_ID = 'XtznP8';
  var ENDPOINT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

  function subscribeToKlaviyo(email) {
    if (!email || email.indexOf('@') === -1) { return; }
    try {
      var body = 'g=' + encodeURIComponent(KLAVIYO_LIST_ID)
               + '&email=' + encodeURIComponent(email)
               + '&$fields=&$list_fields=';
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Cache-Control': 'no-cache' },
        body: body,
        keepalive: true,
        mode: 'no-cors'
      });
    } catch (e) { /* never block the native form */ }
  }

  function isNewsletterForm(form) {
    if (!form || !form.getAttribute) { return false; }
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/contact') === -1) { return false; }
    var tag = form.querySelector('input[name=\"contact[tags]\"]');
    return !!(tag && /newsletter/i.test(tag.value || ''));
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!isNewsletterForm(form)) { return; }
    var emailInput = form.querySelector('input[type=email], input[name=\"contact[email]\"]');
    if (emailInput) { subscribeToKlaviyo(emailInput.value); }
  }, true);
})();
